import { Admin } from "./Admin";

export abstract class AdminRepository {
    abstract register(email: string, password: string): any;
    abstract auth(email: string, password: string): Promise<Admin>;
}